export default "__VITE_ASSET__Dccp131L__"